import React from "react";
import { FaStop } from "react-icons/fa";

export default function Reject(props) {

  return (
    <>
      <div className="icon-button">
        <FaStop/>
      </div>
    </>
  );
}
